<template>
  <div class="container overflow-auto w-screen">
    <div class="m-10 lg:mx-auto">
      <div
        id="compo"
        class="shadow-lg compo bg-white"
        :style="{
          width: `${width}px`,
          height: `${height}px`,
        }"
      >
        <vue-draggable-resizable
          :w="width"
          :h="height"
          :X="x"
          :y="y"
          :style="{
            border: 'none',
          }"
          :parent="true"
          :debug="true"
          :min-width="minWidth"
          :min-height="minHeight"
          :is-conflict-check="false"
          :snap="true"
          :lock-aspect-ratio="true"
          :draggable="draggable"
          :resizable="resizable"
          @resizing="onResize"
          @refLineParams="getRefLineParams"
        ></vue-draggable-resizable>
        <draggable-items
          v-for="(item, key) in items"
          :item="item"
          :key="`dragg-${key}`"
          :label="key"
          :draggable="itemDraggable"
          :resizable="itemResizable"
          :bordersActive="bordersActive"
          @refLineParams="getRefLineParams"
          @setSelected="setSelected"
        ></draggable-items>
        <span
          class="ref-line v-line"
          v-for="(item, index) in vLine"
          :key="`v-line-${index}`"
          v-show="item.display"
          :style="{
            left: item.position,
            top: item.origin,
            height: item.lineLength,
          }"
        />
        <span
          class="ref-line h-line"
          v-for="(item, index) in hLine"
          :key="`h-line-${index}`"
          v-show="item.display"
          :style="{
            top: item.position,
            left: item.origin,
            width: item.lineLength,
          }"
        />
      </div>
      <div class="flex my-5 items-center justify-center">
        <button class="btn btn-primary">Save</button>
        <button @click="toggleDraggResize" class="btn btn-primary">
          <font-awesome-icon :icon="itemDraggable ? 'lock-open' : 'lock'"></font-awesome-icon>&nbsp;Edit Layout
        </button>
        <button @click="createImg" class="btn btn-primary">Download</button>
        <button @click="newItem('image')" class="btn btn-primary">New Item</button>
        <button @click="setLayout('basic')" class="btn btn-primary">Set Basic Layout</button>
        <button @click="bordersActive = !bordersActive" class="btn btn-primary">toggle borders</button>
      </div>
    </div>
  </div>
</template>

<script>
import imageDraggable from '../utils/DragItem.js'
import DraggableItems from '../components/DraggableItems.vue'
import * as htmlToImage from 'html-to-image'
import layouts from '../utils/Layouts'
export default {
  name: 'Canvas',
  components: {
    DraggableItems,
  },
  mounted() {
    window.addEventListener('keyup', (key) => {
      if (key.code == 'Delete' && this.selected != '' && this.itemDraggable) {
        this.$delete(this.items, this.selected)
      }
    })
    this.setLayout('basic')
  },
  data() {
    return {
      width: 842,
      height: 595,
      draggable: false,
      resizable: false,
      itemDraggable: true,
      itemResizable: true,
      background_color: 'white',
      vLine: [],
      hLine: [],
      items: [],
      x: 0,
      y: 0,
      minWidth: 100,
      minHeight: 100,
      index: 0,
      selected: '',
      bordersActive: true,
      layouts,
    }
  },
  methods: {
    toggleDraggResize() {
      this.itemResizable = !this.itemResizable
      this.itemDraggable = !this.itemDraggable
    },
    setSelected(key) {
      this.selected = key
    },
    setLayout(type) {
      this.items = []
      this.$nextTick(() => {
        const items = JSON.parse(JSON.stringify(layouts[type]))
        this.items = items
        this.index = Object.keys(this.items).length
      })
    },
    newItem(key) {
      this.index++
      let image = new imageDraggable(this.index)
      let length = Object.keys(this.items).length
      let unix = Math.round(+new Date()/1000);
      this.$set(this.items,[`layer_${unix}`] , image)
    },
    getRefLineParams(params) {
      const { vLine, hLine } = params
      this.vLine = vLine
      this.hLine = hLine
    },
    createImg() {
      const scale = 2
      this.bordersActive = false
      let domNode = document.getElementById('compo')
      htmlToImage
        .toPng(domNode, {
          width: domNode.offsetWidth * scale,
          height: domNode.offsetHeight * scale,
          style: {
            transform: 'scale(' + scale + ')',
            transformOrigin: 'top left',
          },
        })
        .then((dataUrl) => {
          var link = document.createElement('a')
          link.download = 'compo-image.jpeg'
          link.href = dataUrl
          link.click()
          this.bordersActive = true
        })
      // .toCanvas(domNode)
      // .then(function (canvas) {
      //     document.body.appendChild(canvas);
      // })
    },
    onResize: function (x, y, width, height) {
      this.x = x
      this.y = y
      this.width = width
      this.height = height
    }
  },
}
</script>
